var bibtex = require("bibtex");
window.bibtex = bibtex; // Exposes it to the global window object, to use in other scripts
